import * as classnames from 'classnames';

export const classes = (component: string, ...classNames: (string | undefined)[]) =>
    classnames(`elc-${component}`, `js-${component}`, classNames);
